import { render } from "./CalculatorCompareTable.vue?vue&type=template&id=ed33e866"
import script from "./CalculatorCompareTable.vue?vue&type=script&lang=js"
export * from "./CalculatorCompareTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__